import { FC } from 'react'

import styled from 'styled-components'

import { Equipment } from 'src/Redux/api/equipmentApi.ts'
import { EquipmentItem } from 'src/Components/EquipmentItem'
import { NoDataMessage } from 'src/Components/NoDataMessage'
import { TableLoading } from 'src/Components/TableLoading'

const ListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
  height: 80%;
`

const ContentContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 10px;
  overflow-y: auto;
`

interface TransportTableProps {
  equipments?: Array<Equipment>
  isLoading: boolean
  onArchiveTransport: (id: number) => void
  onEditEquipment: (equipment: Equipment) => void
  isArchiveTransportAvailable: boolean
}

export const TransportTable: FC<TransportTableProps> = ({
  equipments,
  isLoading,
  onArchiveTransport,
  onEditEquipment,
  isArchiveTransportAvailable,
}) => {
  const onEditTransportClick = (equipment: Equipment): void => {
    onEditEquipment(equipment)
  }

  if (isLoading) {
    return (
      <ContentContainer>
        <ListWrapper>
          <TableLoading />
        </ListWrapper>
      </ContentContainer>
    )
  }

  return (
    <ContentContainer>
      <ListWrapper>
        {equipments?.map((equipment) => {
          return (
            <EquipmentItem
              equipment={equipment}
              isArchiveTransportAvailable={isArchiveTransportAvailable}
              key={equipment.id}
              onArchiveItem={onArchiveTransport}
              onEditItem={() => {
                onEditTransportClick(equipment)
              }}
            />
          )
        })}

        {equipments?.length === 0 && <NoDataMessage />}
      </ListWrapper>
    </ContentContainer>
  )
}
